export default {
  en: {
    'components.registration-form-drawer.title.add': 'Add Registration',
    'components.registration-form-drawer.title.edit': 'Edit Registration',
    'components.registration-form-drawer.confirmClose.continue': 'Continue editing',
    'components.registration-form-drawer.confirmClose.discard': 'Discard changes',
    'components.registration-form-drawer.confirmClose.unsaved-changes':
      'You have unsaved changes. Are you sure you want to continue?',
  },
};
